var REACT_ELEMENT_TYPE;function _jsx(type, props, key, children) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var defaultProps = type && type.defaultProps,childrenLength = arguments.length - 3;if (props || 0 === childrenLength || (props = { children: void 0 }), 1 === childrenLength) props.children = children;else if (childrenLength > 1) {for (var childArray = new Array(childrenLength), i = 0; i < childrenLength; i++) childArray[i] = arguments[i + 3];props.children = childArray;}if (props && defaultProps) for (var propName in defaultProps) void 0 === props[propName] && (props[propName] = defaultProps[propName]);else props || (props = defaultProps || {});return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: void 0 === key ? null : "" + key, ref: null, props: props, _owner: null };}import { Field, Form, actions as formActions } from 'react-redux-form';
import { Tabs, TabLink, TabContent } from 'react-tabs-redux';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import Immutable from 'immutable';
import PropTypes from 'prop-types';
import React, { Component } from 'react';

import { Translate } from "../../I18N";
import { SettingsHeader } from "./SettingsHeader";

import saveSettings from "../actions/settingsActions";

class Customisation extends Component {
  componentDidMount() {
    this.props.loadForm('settings.settings', {
      customCSS: this.props.settings.get('customCSS'),
      customJS: this.props.settings.get('customJS')
    });
  }

  render() {
    const allowcustomJS = this.props.settings.get('allowcustomJS');
    return /*#__PURE__*/(
      _jsx("div", { className: "settings-content global-css-js" }, void 0, /*#__PURE__*/
      _jsx("div", { className: "panel-heading" }, void 0,
      allowcustomJS ? /*#__PURE__*/
      _jsx(SettingsHeader, {}, void 0, /*#__PURE__*/
      _jsx(Translate, {}, void 0, "Global CSS & JS")
      ) : /*#__PURE__*/

      _jsx(SettingsHeader, {}, void 0, /*#__PURE__*/
      _jsx(Translate, {}, void 0, "Global CSS")
      )

      ), /*#__PURE__*/
      _jsx(Tabs, {}, void 0, /*#__PURE__*/
      _jsx("div", { style: { position: 'relative' } }, void 0, /*#__PURE__*/
      _jsx(TabLink, { to: "css", default: true, role: "button", tabIndex: "0", "aria-label": "CSS" }, void 0, /*#__PURE__*/
      _jsx(Translate, {}, void 0, "Custom CSS")
      ),
      allowcustomJS && /*#__PURE__*/
      _jsx(TabLink, { to: "js", default: true, role: "button", tabIndex: "0", "aria-label": "JS" }, void 0, /*#__PURE__*/
      _jsx(Translate, {}, void 0, "Custom JS")
      )

      ), /*#__PURE__*/
      _jsx(TabContent, { for: "css", className: "css" }, void 0, /*#__PURE__*/
      _jsx("div", { className: "panel panel-default settings-custom" }, void 0, /*#__PURE__*/
      _jsx("div", { className: "panel-body" }, void 0, /*#__PURE__*/
      _jsx(Form, { model: "settings.settings", onSubmit: this.props.saveSettings }, void 0, /*#__PURE__*/
      _jsx(Field, { model: ".customCSS", className: "field" }, void 0, /*#__PURE__*/
      _jsx("textarea", { className: "form-control", id: "custom_css" })
      ), /*#__PURE__*/
      _jsx("div", { className: "settings-footer" }, void 0, /*#__PURE__*/
      _jsx("div", { className: "btn-cluster content-right" }, void 0, /*#__PURE__*/
      _jsx("button", { type: "submit", className: "btn btn-success btn-extra-padding" }, void 0, /*#__PURE__*/
      _jsx(Translate, {}, void 0, "Save")
      )
      )
      )
      )
      )
      )
      ), /*#__PURE__*/
      _jsx(TabContent, { for: "js", className: "js" }, void 0, /*#__PURE__*/
      _jsx("div", { className: "panel panel-default settings-custom-js" }, void 0, /*#__PURE__*/
      _jsx("div", { className: "panel-body" }, void 0, /*#__PURE__*/
      _jsx(Form, { model: "settings.settings", onSubmit: this.props.saveSettings }, void 0, /*#__PURE__*/
      _jsx(Field, { model: ".customJS" }, void 0, /*#__PURE__*/
      _jsx("textarea", { className: "form-control", id: "custom_js" })
      ), /*#__PURE__*/
      _jsx("div", { className: "settings-footer" }, void 0, /*#__PURE__*/
      _jsx("div", { className: "btn-cluster content-right" }, void 0, /*#__PURE__*/
      _jsx("button", { type: "submit", className: "btn btn-success btn-extra-padding" }, void 0, /*#__PURE__*/
      _jsx(Translate, {}, void 0, "Save")
      )
      )
      )
      )
      )
      )
      )
      )
      ));

  }
}







const mapStateToProps = (state) => ({ settings: state.settings.collection });
const mapDispatchToProps = (dispatch) =>
bindActionCreators(
  {
    loadForm: formActions.load,
    saveSettings
  },
  dispatch
);

export { Customisation };

export default connect(mapStateToProps, mapDispatchToProps)(Customisation);